var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 57,
    viewBox: "0 0 70 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5001 49.875V45.125C60.5001 42.6054 59.4992 40.1891 57.7176 38.4075C55.936 36.6259 53.5196 35.625 51.0001 35.625H32.0001C29.4805 35.625 27.0641 36.6259 25.2825 38.4075C23.501 40.1891 22.5001 42.6054 22.5001 45.125V49.875M51.0001 16.625C51.0001 21.8717 46.7468 26.125 41.5001 26.125C36.2534 26.125 32.0001 21.8717 32.0001 16.625C32.0001 11.3783 36.2534 7.125 41.5001 7.125C46.7468 7.125 51.0001 11.3783 51.0001 16.625Z",
    stroke: "#171898",
    strokeOpacity: 0.5,
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.675 49.875V45.125C47.675 42.6054 46.6742 40.1891 44.8926 38.4075C43.111 36.6259 40.6946 35.625 38.1751 35.625H19.175C16.6555 35.625 14.2391 36.6259 12.4575 38.4075C10.6759 40.1891 9.67505 42.6054 9.67505 45.125V49.875",
    fill: "#DBDCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6751 26.125C33.9218 26.125 38.1751 21.8717 38.1751 16.625C38.1751 11.3783 33.9218 7.125 28.6751 7.125C23.4283 7.125 19.175 11.3783 19.175 16.625C19.175 21.8717 23.4283 26.125 28.6751 26.125Z",
    fill: "#DBDCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.675 49.875V45.125C47.675 42.6054 46.6742 40.1891 44.8926 38.4075C43.111 36.6259 40.6946 35.625 38.1751 35.625H19.175C16.6555 35.625 14.2391 36.6259 12.4575 38.4075C10.6759 40.1891 9.67505 42.6054 9.67505 45.125V49.875M38.1751 16.625C38.1751 21.8717 33.9218 26.125 28.6751 26.125C23.4283 26.125 19.175 21.8717 19.175 16.625C19.175 11.3783 23.4283 7.125 28.6751 7.125C33.9218 7.125 38.1751 11.3783 38.1751 16.625Z",
    stroke: "#171898",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.573fe3b6e88d0efd5a6fbb34e5df48c4.svg";
export { ForwardRef as ReactComponent };